import React from 'react';
import { Box, IconButton, Typography } from "@mui/material";
import { ComponentType, TComponentCategory, TComponentItem, TMenuItem } from '../types';
import { getFixedImageUrl } from '../api';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import StyledPaper from './StyledPaper';
import PriceRender from './PriceRender';
import parsePrice from '../utils/parsePrice';
import { t } from '@lingui/macro';

type MenuItemProps = {//TODO: clean up the signature
    item: TMenuItem
    quantityInOrder: number,
    withOptions?: boolean
    onShowClick: () => void,
    onAddClick: () => void,
    onRemoveClick: () => void,
    isOrderActive?: boolean,
    isCheckout?: boolean,
}

const cartDescription = (item: TMenuItem): string[] => {

    var itemDescription: string[] = [];
    
    for (let i = 0; i < item.components.length; i++) {
        const component = item.components[i];

        if (component.isBase) { continue }

        itemDescription.push(descriptionForComponent(component));
    }

    return itemDescription
}

const descriptionForComponent = (component: TComponentCategory): string => {

    const totalSelected = component.options.reduce((acc, value) => acc + value.value, 0)

    const optionsDescription: string[] = []
    const supportsAggregation = component.maxSelected == component.options.length
 
    if (component.options.length == 1) {
        const option = component.options[0]
        const description = descriptionForOption(option);
        if (description != null) {
            optionsDescription.push(description)
        } 
    } else if (component.options.length == totalSelected && supportsAggregation) {
        optionsDescription.push(t`all`)
    } else {
        for (let i = 0; i < component.options.length; i++) {
            const option = component.options[i]
            const description = descriptionForOption(option);
            if (description != null) {
                optionsDescription.push(description)
            } 
        }
    }

    if (optionsDescription.length == 0) {
        return component.name.toLocaleLowerCase() + ": " + t`without`
    }

    return component.name + ": " + optionsDescription.join(", ")
}

const descriptionForOption = (option: TComponentItem): string | null => {

if (option.value == 1) {
    return option.name.toLowerCase()
} else if (option.value > 1) {
    return option.name.toLowerCase() + " x" + option.value
}
return null
}

const MenuItem: React.FC<MenuItemProps> = (props) => {
    const {
        item,
        item: { imagePath, name, components },
        onAddClick,
        onShowClick,
        onRemoveClick,
        quantityInOrder,
        withOptions,
        isOrderActive,
        isCheckout
    } = props;
    const price = parsePrice(item);
    var itemTitle = name;
    const baseComponent = components.filter((value) => value.isBase)[0];
    const componentSelectedOption = baseComponent?.options?.filter((value) => value.value > 0)[0];
    if (componentSelectedOption?.name) {
        itemTitle = name + " " + componentSelectedOption.name;
    }
    
    var itemDescription = cartDescription(item);

    return <StyledPaper
        onClick={onShowClick}
        elevation={1}
        sx={{ display: 'flex', padding: '10px 12px', borderRadius: '16px', alignItems: withOptions ? 'start' : 'center', height: withOptions ? 'unset' : '100px' }}>
        <Box pr='12px'>
            <img style={{ width: '100px', height: '100px', borderRadius: '50%' }} loading="lazy" src={getFixedImageUrl(imagePath)} alt={`${name}`} />
        </Box>
        <Box flex={1}>
            <Typography variant='body1'>{itemTitle}</Typography>
            <Box pb='8px' />
            {withOptions && <>
                {itemDescription
                    .map(option => <Typography
                        fontSize={'12px'}
                        fontWeight={600}
                        color={'#C0C0CF'}
                    >
                        {option}
                    </Typography>)}
                <Box pb='8px' />
            </>}
            <PriceRender price={price} color={'#FF7B2C'} />
        </Box>
        {!isOrderActive && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={withOptions ? 'start' : 'end'} height={'100%'}>
                {Boolean(quantityInOrder) && (isCheckout || item.components.length === 0) && <>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation()
                                onRemoveClick()
                            }}
                            size='small'
                            sx={{ height: '32px', width: '32px', backgroundColor: '#fff2ea' }}
                            color='warning'>
                            <RemoveOutlinedIcon />
                        </IconButton>
                        <Box justifyContent={'center'} flex='1' alignItems={'center'} my={'12px'}>
                            <Typography variant='body2' sx={{ lineHeight: '10px' }}>{quantityInOrder}</Typography>
                        </Box>
                    </>}
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation()
                        onAddClick()
                    }}
                    size='small'
                    sx={{ height: '32px', width: '32px', backgroundColor: '#fff2ea' }}
                    color='warning'>
                    <AddOutlinedIcon />
                </IconButton>
            </Box>}
    </StyledPaper>
}

export default MenuItem;